const version = `v17.0`;

const appId = process.env.REACT_APP_FACEBOOK_APP_ID;

const src = `https://connect.facebook.net/en_GB/sdk.js`;

const scope = 'pages_messaging,pages_show_list,pages_manage_metadata';

export { version, appId, src, scope };
